import React from 'react';
import './accordion.scss';

export interface AccordionItemProps {
    children: any;
    isOpen?: boolean;
}

const AccordionItem = ({children, isOpen}: AccordionItemProps) => {
    return (
        <div className={`accordion ${isOpen ? 'open' : ''}`}>
            {children}
        </div>
    )
}

export default AccordionItem;
